import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from '../shared/crud.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SponsorService extends CrudService {

  constructor(protected http: HttpClient) {
    super(http);
    this.setObject('sponsor');
  }

  update(data: any): Observable<any> {
    return this.http.post(this.apiUrl + this.object + '/' + data.id, data);
  }
}
